import Calendar from './../../modules/components/Calendar';
import PricingCalculator from '../../modules/components/PricingCalculator';
export default class ReservationEditPicker {
    constructor(container, picker = null) {
        this.container = container;
        this.picker = picker;
        this.availableDates = {};
        this.selectedTime = null;
        this.selectedDate = null;
        this.parseViewData();
        this.parseAvailableDates();
        this.createTimePeriodsContainer();
        this.initTotalCalculation();
        this.initGuestCounters();
        this.initDurationPicker();
        this.initAdditionalServices();
        this.initCalendarPicker();
        this.updateTotal();
    }
    parseViewData() {
        const viewDataElement = document.getElementById('view-data');
        if (viewDataElement) {
            try {
                this.viewData = JSON.parse(viewDataElement.textContent || '{}');
            }
            catch (error) {
                this.viewData = {
                    adults_price: 0,
                    teenagers_price: 0,
                    kids_price: 0,
                    duration_days: 1,
                    dynamic_duration_days: false,
                    units: 'Units',
                    price_by_person_amount: null,
                    price_by_weekday: null
                };
            }
        }
    }
    initGuestCounters() {
        const counterButtons = this.container.querySelectorAll('.counter-controls input');
        counterButtons.forEach(input => {
            input.addEventListener('change', () => this.updateTotal());
        });
    }
    initDurationPicker() {
        this.durationInput = this.container.querySelector('#duration_days');
        if (!this.durationInput) {
            return;
        }
        this.durationInput.addEventListener('change', () => this.updateTotal());
    }
    initAdditionalServices() {
        var _a, _b;
        const additionalServiceInputs = (_b = (_a = this.container) === null || _a === void 0 ? void 0 : _a.closest('form')) === null || _b === void 0 ? void 0 : _b.querySelectorAll('input[type="radio"][name^="additional_services["]');
        additionalServiceInputs === null || additionalServiceInputs === void 0 ? void 0 : additionalServiceInputs.forEach(input => {
            input.addEventListener('change', () => this.updateTotal());
        });
    }
    initTotalCalculation() {
        this.adultInput = this.container.querySelector('#adults');
        this.teenagerInput = this.container.querySelector('#teenagers');
        this.kidInput = this.container.querySelector('#kids');
        this.totalElement = this.container.querySelector('[data-total-amount]');
        if (!this.adultInput || !this.totalElement) {
            console.error('Missing form elements required for total calculation');
        }
    }
    updateTotal() {
        const guestCounts = PricingCalculator.getGuestCounts(this.container);
        const durationDays = PricingCalculator.getDurationDays(this.container, this.viewData);
        const reservationDate = this.container.closest('form').querySelector('[name=reservation_date]');
        PricingCalculator.calculateAndUpdateTotal(this.totalElement, {
            viewData: this.viewData,
            guestCounts,
            durationDays,
            container: this.container,
            formContainer: this.container.closest('form'),
            reservationDate: reservationDate ? reservationDate.value : null
        });
    }
    initCalendarPicker() {
        const dateField = this.container.querySelector('[name=reservation_date]');
        if (dateField) {
            const firstAvailableMonth = this.findFirstAvailableMonth();
            const calendar = new Calendar({
                field: dateField,
                singleDate: true,
                format: 'YYYY-MM-DD',
                inline: true,
                parentEl: dateField.parentElement,
                disableDates: this.generateDisabledDatesArray(),
                startDate: firstAvailableMonth,
                onSelect: (date) => {
                    if (date) {
                        this.selectedDate = this.formatDate(date);
                        this.updateAvailableTimes(date);
                        this.updateTotal();
                    }
                },
                onMonthChange: () => {
                    setTimeout(() => {
                        this.autoSelectFirstAvailableDate();
                    }, 100);
                }
            });
            this.picker = calendar.getPicker();
            setTimeout(() => {
                this.autoSelectFirstAvailableDate();
            }, 100);
        }
    }
    findFirstAvailableMonth() {
        const availableDateStrings = Object.keys(this.availableDates);
        if (availableDateStrings.length === 0) {
            return new Date();
        }
        availableDateStrings.sort();
        const earliestDate = new Date(availableDateStrings[0]);
        return new Date(earliestDate.getFullYear(), earliestDate.getMonth(), 1);
    }
    autoSelectFirstAvailableDate() {
        const availableDay = this.container.querySelector('.lightpick__day.is-available.is-start-date');
        if (availableDay && !this.selectedDate) {
            availableDay.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
        }
    }
    parseAvailableDates() {
        const datesData = this.container.getAttribute('data-available-dates');
        if (datesData) {
            try {
                this.availableDates = JSON.parse(datesData);
            }
            catch (error) {
                console.error('Error parsing available dates:', error);
            }
        }
    }
    createTimePeriodsContainer() {
        this.timePeriodsContainer = document.createElement('div');
        this.timePeriodsContainer.className = 'time-periods-container';
        const dateField = this.container.querySelector('[name=reservation_date]');
        if (dateField && dateField.parentElement) {
            dateField.parentElement.after(this.timePeriodsContainer);
        }
    }
    generateDisabledDatesArray() {
        const availableDateStrings = Object.keys(this.availableDates);
        if (availableDateStrings.length === 0) {
            return [];
        }
        const availableDatesSet = new Set(availableDateStrings);
        const disabledRanges = [];
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const futureDate = new Date();
        futureDate.setFullYear(futureDate.getFullYear() + 1);
        let currentDate = new Date(today);
        let rangeStart = null;
        while (currentDate <= futureDate) {
            const dateString = this.formatDate(currentDate);
            if (!availableDatesSet.has(dateString)) {
                if (!rangeStart) {
                    rangeStart = new Date(currentDate);
                }
            }
            else {
                if (rangeStart) {
                    const rangeEnd = new Date(currentDate.getTime() - 86400000);
                    disabledRanges.push([rangeStart, rangeEnd]);
                    rangeStart = null;
                }
            }
            currentDate.setDate(currentDate.getDate() + 1);
        }
        if (rangeStart) {
            disabledRanges.push([rangeStart, futureDate]);
        }
        return disabledRanges;
    }
    formatDate(date) {
        const dateObj = date instanceof Date ? date : new Date(date);
        if (isNaN(dateObj.getTime())) {
            console.error('Invalid date provided to formatDate:', date);
            return '';
        }
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const day = String(dateObj.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    updateAvailableTimes(selectedDate) {
        const dateStr = this.formatDate(selectedDate);
        const timesForDate = this.availableDates[dateStr] || [];
        this.renderTimePeriods(timesForDate);
    }
    renderTimePeriods(times) {
        this.timePeriodsContainer.innerHTML = '';
        if (times.length === 0) {
            return;
        }
        const hasOnlyMidnight = times.length === 1 && times[0].time === '00:00';
        if (hasOnlyMidnight) {
            const hiddenInput = document.createElement('input');
            hiddenInput.type = 'hidden';
            hiddenInput.name = 'time_period';
            hiddenInput.value = '00:00';
            hiddenInput.setAttribute('data-time', '00:00');
            this.timePeriodsContainer.appendChild(hiddenInput);
            this.selectedTime = '00:00';
            return;
        }
        const hasOnlyOneTime = times.length === 1;
        const currentTime = this.container.getAttribute('data-current-time') || '';
        times.forEach(timeRow => {
            const fieldDiv = document.createElement('div');
            fieldDiv.className = 'form-field form-field-radio';
            const label = document.createElement('label');
            label.setAttribute('for', `time-${timeRow.time}`);
            const input = document.createElement('input');
            input.type = 'radio';
            input.name = 'time_period';
            input.id = `time-${timeRow.time}`;
            input.value = timeRow.time;
            input.setAttribute('data-time', timeRow.time);
            if (hasOnlyOneTime || currentTime.includes(timeRow.time)) {
                input.checked = true;
                this.selectedTime = timeRow.time;
            }
            const span = document.createElement('span');
            span.textContent = this.formatDisplayTime(timeRow.time);
            label.appendChild(input);
            label.appendChild(span);
            fieldDiv.appendChild(label);
            this.timePeriodsContainer.appendChild(fieldDiv);
        });
    }
    formatDisplayTime(timeStr) {
        const [hours, minutes] = timeStr.split(':');
        const date = new Date();
        date.setHours(parseInt(hours, 10));
        date.setMinutes(parseInt(minutes, 10));
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
    }
}
